import React, { useEffect, useState, useCallback, useRef } from "react";
import cn from "classnames";
import styles from "./ViewFirmware.module.scss";
import Master from "screen/Master";

var id = undefined;
var view = undefined;

function SwapStationView(props) {
  view = props?.match?.params?.view;
  id = props?.match?.params?.id;

  const firmwareData1 = props.location.state.firmwareData;
  const selectedFirmware =
    firmwareData1.find((item) => item.stationID === id) || {};

  return (
    <>
      <div className={cn(styles.flex_item)}>
        <h2>Firmware OTA</h2>
        <h3>&gt;</h3>
        <h3>View Swap Station</h3>
      </div>

      <div className={cn(styles.flex_block)}>
        <h1>View Swap Station</h1>
        <div className={cn(styles.flex_block1)}>
          <h4>Firmware Status : Up to Date</h4>
          <h5>online</h5>
        </div>
      </div>

      <div className={cn(styles.main_block)}>
        <h6> Swap Station Details</h6>
        <div className={cn(styles.block1)}>
          <div className={cn(styles.block1_layout)}>
            <div className={cn(styles.block1_text)}>
              <h1>Station Id</h1>
              <h2>{"xxxxx"}</h2>
            </div>
            <div className={cn(styles.block1_text)}>
              <h1>Model</h1>
              <h2>{"xxxx"}</h2>
            </div>
          </div>
          <div className={cn(styles.block1_layout)}>
          <div className={cn(styles.block1_text)}>
              <h1>No of Slots</h1>
              <h2>{"XX"}</h2>
            </div>
           
           
          </div>
          <div className={cn(styles.block1_layout)}>
          <div className={cn(styles.block1_text)}>
              <h1>Power(in KWH)</h1>
              <h2>{"xxxxxx"}</h2>
            </div>
          
          </div>
          <div className={cn(styles.block1_layout)}>
            <div className={cn(styles.block1_text)}>
              <h1>Make</h1>
              <h2>{"xxxxxx"}</h2>
            </div>
          </div>
        </div>
      </div>
      <div className={cn(styles.main_block)}>
        <h6> Firmware Details</h6>
        <div className={cn(styles.block1)}>
          <div className={cn(styles.block1_layout)}>
            <div className={cn(styles.block1_text)}>
              <h1>Firmware Id</h1>
              <h2>{"xxxxxxx"}</h2>
            </div>
            <div className={cn(styles.block1_text)}>
              <h1>Release Note</h1>
              <h2>{"xxxx"}</h2>
            </div>
          </div>
          <div className={cn(styles.block1_layout)}>
            <div className={cn(styles.block1_text)}>
              <h1>Last Updated On</h1>
              <h2>{"xxxxxxx"}</h2>
            </div>
           
          </div>
          <div className={cn(styles.block1_layout)}>
          
            <div className={cn(styles.block1_text)}>
              <h1>Firmware Version</h1>
              <h2>XXXXXXX</h2>
            </div>
          </div>
          <div className={cn(styles.block1_layout)}>
            <div className={cn(styles.block1_text)}>
              <h1>Size</h1>
              <h2>{"xxx MB"}</h2>
            </div>
          </div>
        </div>
      </div>
      <div className={cn(styles.main_block)}>
        <h6> Location Details</h6>
        <div className={cn(styles.block1)}>
          <div className={cn(styles.block1_layout)}>
            <div className={cn(styles.block1_text)}>
              <h1>Site Name</h1>
              <h2>{"xxxxx"}</h2>
            </div>
           
          </div>
          <div className={cn(styles.block1_layout)}>
            <div className={cn(styles.block1_text)}>
              <h1>City </h1>
              <h2>{"xxxxxx"}</h2>
            </div>
           
          </div>
          <div className={cn(styles.block1_layout)}>
            <div className={cn(styles.block1_text)}>
              <h1>State</h1>
              <h2>{"xxxxx"}</h2>
            </div>
           
          </div>
          <div className={cn(styles.block1_layout)}>
            <div className={cn(styles.block1_text)}>
              <h1>Country</h1>
              <h2>{"xxxx"}</h2>
            </div>
          </div>
        </div>
      </div>

      
     
    </>
  );
}

export default function ViewFirmwareSwapStation(props) {
  return (
    <>
      <Master opts={props} screen={SwapStationView} showStatus={false} />
    </>
  );
}

ViewFirmwareSwapStation.inStorybook = true;
